import React from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import EmptyCart from "@/../public/images/icons/empty-cart.svg";

const CartEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-center px-4 h-100">
      <div className="mb-3 mb-md-4">
        <Image
          src={EmptyCart}
          alt={t("Empty cart")}
          className="d-block d-md-none"
          style={{ width: 177, height: 129, objectFit: "contain" }}
        />
        <Image
          src={EmptyCart}
          alt={t("Empty cart")}
          className="d-none d-md-block"
          style={{ width: 175, height: 144, objectFit: "contain" }}
        />
      </div>

      <div className="fw-bold fs-24 mb-2">{t("Nothing added")}</div>

      <div className="fs-16 text-grey-text mx-auto" style={{ maxWidth: 300 }}>
        {t("Select dishes from the menu to place an order.")}
      </div>
    </div>
  );
};

export default React.memo(CartEmptyState);
